import {
    GA_HOME_CATEGORY,
    GA_HOME_FEED_CATEGORY,
    GA_POOR_CONTENT_ACTION,
    GA_SMALL_CITY_FALLBACK_ACTION,
} from '../../constants/analytics';

import {
    isSmallCityFallback,
    isZeroContent,
} from '../../utils/content';

const trackContentQuality = ({action, label, loggedIn = true}) => ({
    type: 'POOR_CONTENT',
    meta: {
        analytics: {
            category: loggedIn ? GA_HOME_FEED_CATEGORY : GA_HOME_CATEGORY,
            action,
            label,
            nonInteraction: true,
        },
    },
});

export const verifyPoorContent = ({buckets, events, actionName}) => (
    (dispatch, getState) => {
        const {
            location: {currentPlace},
            user: {isAuthenticated},
        } = getState();
        const actionLabel = actionName ? `- ${actionName}` : '';

        if (isSmallCityFallback({buckets, events})) {
            dispatch(trackContentQuality({
                loggedIn: isAuthenticated,
                action: GA_SMALL_CITY_FALLBACK_ACTION + actionLabel,
                label: currentPlace,
            }));
        }

        if (isZeroContent({buckets, events})) {
            dispatch(trackContentQuality({
                loggedIn: isAuthenticated,
                action: GA_POOR_CONTENT_ACTION + actionLabel,
                label: currentPlace,
            }));
        }
    }
);

export const UPDATE_TAB_KEY = 'UPDATE_TAB_KEY';
export const updateTabKey = (payload) => ({
    type: UPDATE_TAB_KEY,
    payload,
});

export const UPDATE_CONTENT = 'UPDATE_CONTENT';
export const updateContent = ({entities, entityContext}) => ({
    type: UPDATE_CONTENT,
    payload: {
        entities,
        entityContext,
    },
});
